module.exports = __webpack_public_path__ + "static/media/slakteweb-tekst-logo.512d4e80.svg";